import { DJ_GETLISTADO_COMPLETE } from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  listado: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DJ_GETLISTADO_COMPLETE:
      let dias = get(action, "payload");
      return { ...state, listado: dias };
    default:
      return { ...state };
  }
}
